module.exports = __webpack_public_path__ + "static/media/header-10.d015dc67.png";